import { Record, Map, List } from 'immutable';
import { COMPONENTS, ADSTATES } from 'Reducers/ad/utils';
import { getAd } from 'Selectors/';

export default class AdStateRecord extends Record({
  key: '',
  name: '',
  script: '',
  selected: false,
  dimensions: Map({ left: 0, top: 0, width: 0, height: 0 }),
  viewport: Map({ width: 0, height: 0 }),
  offsetHeight: 0,
  components: List(),
  backgroundColor: '#ffffff',
  borderColor: '#000000',
  borderWidth: '0px',
  currentTime: 0,
  startTime: 0,
  endTime: 30,
  duration: 30,
  loop: 1,
  variants: new List(),
  isBuildGuide: false,
}) {
  componentList(ad) {
    const adStateFromState = ad.getIn([ADSTATES, this.key]);
    return adStateFromState.components
      .map(c => ad.getIn([COMPONENTS, c]).toList(ad))
      .flatten(true);
  }

  getComponents(ad) {
    const components = ad.getIn([COMPONENTS]);

    return this.components.map(componentId => components.get(componentId));
  }

  getFonts(state) {
    const components = this.getComponents(getAd(state));
    return components.map(c => c.getFont(state)).filter(font => font).toSet().toList();
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/records/AdStateRecord.js